<template>
  <div class="transaction-receipt-template is-a5">
    <!-- Header: Store Info -->
    <div class="header text-center mb-3">
      <div class="company-name font-weight-bold">{{ system.storeName }}</div>
      <div class="company-detail">Địa chỉ: {{ system.address }}</div>
      <div class="company-detail">Điện thoại: {{ system.phone }}</div>
    </div>

    <!-- Receipt Title -->
    <div class="text-center bill-title-section mt-4 mb-4">
        <h4 class="bill-title font-weight-bold">
            {{ data.type === 'income' ? (config.incomeTitle || 'PHIẾU THU') : (config.expenseTitle || 'PHIẾU CHI') }}
        </h4>
    </div>

    <!-- Transaction Info -->
    <div class="info-section mb-4">
      <div class="info-row d-flex justify-content-between mb-2">
        <span class="info-left"><b>Thời gian:</b> {{ formatDateTime(data.createdAt || new Date()) }}</span>
        <span class="info-right"><b>Người lập phiếu:</b> {{ data.createdBy || '---' }}</span>
      </div>
      <div class="info-row mb-2">
        <span class="info-left d-block"><b>Lý do / Nội dung:</b> {{ data.note || '---' }}</span>
      </div>
      <div class="info-row mb-2" v-if="data.folder">
        <span class="info-left d-block"><b>Thư mục chứa phiếu:</b> {{ data.folder }}</span>
      </div>
    </div>

    <!-- Payment Details -->
    <div class="payment-details-section mb-4 mt-5">
      <table class="table table-bordered border-dark">
        <tbody>
          <tr>
            <td class="font-weight-bold p-4" style="width: 50%;">Tổng tiền ({{ data.type === 'income' ? '+' : '-' }}):</td>
            <td class="text-right font-weight-bold p-4" :class="data.type === 'income' ? 'text-success' : 'text-danger'" style="font-size: 32px !important;">
                {{ Number(data.amount || 0).toLocaleString() }}₫
            </td>
          </tr>
          <tr v-if="data.cash_amount > 0">
            <td class="pl-5"><i>- Bằng Tiền mặt:</i></td>
            <td class="text-right"><i>{{ Number(data.cash_amount || 0).toLocaleString() }}₫</i></td>
          </tr>
          <tr v-if="data.transfer_amount > 0">
            <td class="pl-5"><i>- Bằng Chuyển khoản:</i></td>
            <td class="text-right"><i>{{ Number(data.transfer_amount || 0).toLocaleString() }}₫</i></td>
          </tr>
        </tbody>
      </table>
      
      <!-- Amount in words (Số tiền bằng chữ) -->
      <div class="mt-4 info-left">
          <i><b>Số tiền bằng chữ:</b> {{ numberToVietnameseWords(data.amount || 0) }} đồng chẵn.</i>
      </div>
    </div>

    <!-- Signature Area -->
    <div class="signature-section d-flex justify-content-around mt-5 pt-5">
      <div class="sig-box text-center">
        <div class="font-weight-bold mb-5 pb-5">{{ data.type === 'income' ? 'NGƯỜI NỘP TIỀN' : 'NGƯỜI NHẬN TIỀN' }}</div>
        <div class="mt-5 pt-4 text-muted">(Ký, ghi rõ họ tên)</div>
      </div>
      <div class="sig-box text-center">
        <div class="font-weight-bold mb-5 pb-5">NGƯỜI THU TIỀN</div>
        <div class="mt-5 pt-4 text-muted">(Ký, ghi rõ họ tên)</div>
      </div>
      <div class="sig-box text-center">
        <div class="font-weight-bold mb-5 pb-5">NGƯỜI LẬP PHIẾU</div>
        <div class="mt-5 pt-4 text-muted">(Ký, ghi rõ họ tên)</div>
      </div>
    </div>

    <!-- Footer -->
    <div class="footer-section text-center mt-5 pt-4">
      <div class="footer-note mb-1">
        <i>{{ data.type === 'income' ? 'Xin cảm ơn Quý khách!' : '---' }}</i>
      </div>
      <div class="software-credit small text-muted mt-3">
        Phần mềm quản lý bán hàng - cuongdev.pro.vn
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TransactionReceiptTemplate',
  props: {
    data: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      default: () => ({
        incomeTitle: 'PHIẾU THU',
        expenseTitle: 'PHIẾU CHI'
      })
    },
    system: {
      type: Object,
      default: () => ({
          storeName: 'Cửa hàng Lô Gạch',
          address: 'Chưa cập nhật',
          phone: '',
          logo: ''
      })
    },
    settings: {
      type: Object,
      default: () => ({
        showCompanyLogo: true
      })
    }
  },
  methods: {
    formatDateTime(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return d.toLocaleString('vi-VN', {
        hour: '2-digit', minute:'2-digit',
        day: '2-digit', month: '2-digit', year: 'numeric'
      });
    },
    numberToVietnameseWords(num) {
      num = Math.abs(Math.round(Number(num) || 0));
      if (num === 0) return 'không';

      const ones = ['', 'một', 'hai', 'ba', 'bốn', 'năm', 'sáu', 'bảy', 'tám', 'chín'];
      const units = ['', 'nghìn', 'triệu', 'tỷ', 'nghìn tỷ', 'triệu tỷ'];

      const readGroup = (n) => {
        const h = Math.floor(n / 100);
        const t = Math.floor((n % 100) / 10);
        const u = n % 10;
        let result = '';

        if (h > 0) {
          result += ones[h] + ' trăm';
          if (t === 0 && u > 0) result += ' lẻ';
        }
        if (t > 1) {
          result += ' ' + ones[t] + ' mươi';
          if (u === 1) result += ' mốt';
          else if (u === 5) result += ' lăm';
          else if (u > 0) result += ' ' + ones[u];
        } else if (t === 1) {
          result += ' mười';
          if (u === 5) result += ' lăm';
          else if (u > 0) result += ' ' + ones[u];
        } else if (u > 0) {
          result += ' ' + ones[u];
        }

        return result.trim();
      };

      const groups = [];
      while (num > 0) {
        groups.push(num % 1000);
        num = Math.floor(num / 1000);
      }

      let result = '';
      for (let i = groups.length - 1; i >= 0; i--) {
        if (groups[i] > 0) {
          result += readGroup(groups[i]) + ' ' + units[i] + ' ';
        }
      }

      result = result.trim();
      // Capitalize first letter
      return result.charAt(0).toUpperCase() + result.slice(1);
    }
  }
}
</script>

<style scoped>
.transaction-receipt-template {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  color: #000;
  width: 100%;
  padding: 0;
  margin: 0;
  background-color: white;
  box-sizing: border-box;
  font-size: 16px;
}
.table-bordered th, .table-bordered td {
  border: 1px solid #000 !important;
  padding: 12px 15px;
  font-size: 16px;
}
.company-name {
  font-size: 1.5rem !important;
}
.bill-title {
  font-size: 1.8rem !important;
}

@media print {
  .transaction-receipt-template {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
    font-size: 27px;
    box-sizing: border-box !important;
  }
  .company-name {
    font-size: 39px !important;
  }
  .company-detail {
    font-size: 27px;
    margin-bottom: 9px;
  }
  .bill-title {
    font-size: 42px !important;
    margin-top: 45px !important;
    margin-bottom: 45px !important;
  }
  .info-left, .info-right {
    font-size: 27px;
  }
  .info-row {
    margin-bottom: 22px !important;
  }
  .table-bordered th, .table-bordered td {
    padding: 24px 22px !important;
    font-size: 27px;
  }
  .sig-box .font-weight-bold {
    font-size: 24px;
    margin-bottom: 120px !important;
  }
  .sig-box .text-muted {
    font-size: 21px;
    color: #333 !important;
  }
  .footer-note {
    font-size: 27px;
    margin-top: 30px;
  }
  .software-credit {
    font-size: 21px;
  }
}
</style>
